export default class PredictionRequestModel {
    public gameInstanceId: string = null;
    public fixtures: any[] = null;
}